<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9jVWPu/tc-custom/9781480432857.jpg?1744295919987" alt="This image is the cover for the book Charioteer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Charioteer
      </h1>
      <p class="bookDescription body article font2">
        <b>A WWII soldier embarks on affairs with two very different men in a landmark novel that </b><b>“transcends categorizations” (<i>The Telegraph</i>).</b><br/>  After being wounded at Dunkirk in World War II, Laurie Odell is sent back home to a rural British hospital. Standing out among the orderlies is Andrew, a bright conscientious objector raised as a Quaker. The unspoken romance between the two men is tested when Ralph, a friend of Laurie’s from school, re-enters his life, introducing him into a milieu of jaded, experienced gay men. Will Laurie reconcile himself to Ralph’s embrace, or can he offer Andrew the idealized, Platonic intimacy he yearns for?<br/> This novel has been called one of the foundation stones of gay literary fiction, ranking alongside James Baldwin’s <i>Giovanni’s Room </i>and Gore Vidal’s <i>The City and the Pillar</i>. Celebrated for its literary brilliance and sincere depiction of complex human emotions, <i>The Charioteer </i>is a stirring and beautifully rendered portrayal of love.<br/> This ebook features an illustrated biography of Mary Renault including rare images of the author.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Renault
      </h2>
      
      <p class="authorDescription body article">Born in London as Eileen Mary Challans in 1905 and educated at the University of Oxford, Mary Renault trained as a nurse at Oxford's Radcliffe Infirmary. It was there that she met her lifelong partner, fellow nurse Julie Mullard. After completing her training, Renault wrote her first novel,&#160;<I>Purposes of Love</I>, in 1937. In 1948, after her novel&#160;<I>Return to Night</I>&#160;won an MGM prize worth $150,000, she and Mullard immigrated to South Africa. There, Renault wrote the historical novels that would define her career. In 2006, Renault was the subject of a BBC 4 documentary, and her books, many of which remain in print on both sides of the Atlantic, are often sought after for radio and dramatic interpretation. In 2010,&#160;<I>Fire From Heaven&#160;</I>was shortlisted for the 1970 Lost Booker prize.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b1417af0